import React from 'react';

import SearchClearFilter from '../../search-filter/components/search-clear-filter';
import SearchFilterCrumbs from '../../search-filter/components/search-filter-crumbs';

class VWAFilterCount extends React.PureComponent {

    static defaultProps = {
        watchFields: /facets.*|price|rating/
    }

    render(){
        const { watchFields } = this.props;
        return (<div className='filter-count-bar'>
            <SearchFilterCrumbs>
            {
                 ({ disableSearch, filterCount }) => {
                     {
                        if(disableSearch){
                            return null
                        }
                        return (<React.Fragment>
                                    {filterCount > 0 && 
                                        <span tabIndex={0}><span  className="count">{filterCount}</span><span className={'count-label'}>{` FILTER${filterCount > 1 ? 'S' : ''} APPLIED`}</span></span>}
                                    <SearchClearFilter 
                                        autoHide={true}
                                        watchFields={watchFields}
                                        isV2={true}
                                    />
                                </React.Fragment>);
                    }
                 }
            }
            </SearchFilterCrumbs>
        </div>)
    }
}

export default VWAFilterCount;
